import { render, staticRenderFns } from "./company-authorizer-info.html?vue&type=template&id=80c1ae8e&scoped=true&external"
import script from "./company-authorizer-info.js?vue&type=script&lang=js&external"
export * from "./company-authorizer-info.js?vue&type=script&lang=js&external"
import style0 from "./company-authorizer-info.scss?vue&type=style&index=0&id=80c1ae8e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c1ae8e",
  null
  
)

export default component.exports